import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/Modal/GenericModal'
import downloadIcon from 'images/download_white.svg'
import TextLink from 'component/TextLink'
import moment from 'moment'

let timer = null

const QueryLogsModal = (props) => {
  const {
    closeModal,
    handleDownload,
    data: { request, response, endpoint, date, functionality, transactionSap },
    translate,
  } = props

  const DEFAULT_COPIED_STATE = {
    endpoint: false,
    request: false,
    response: false
  }

  const [copied, setCopied] = useState(DEFAULT_COPIED_STATE)

  const displayResponse = functionality === 'demarcate' && response === 'REJECTED'
    ? translate('query.logs.demarcate.response.rejected')
    : response

  return (
    <Modal
      title={translate('log.details')}
      size={'md'}
      isOpen
      onCloseModal={closeModal}
      disabledBgClickClosing
      showHeader
      showFooter
      center={false}
      className="query-logs-modal"
      confirmButtonText={
        <>
          <img src={downloadIcon} width='12' height='12' />
          <span style={{ color: '#fff' }}>{translate('download.txt')}</span>
        </>
      }
      cancelButtonText={translate('close_button_label')}
      onConfirm={() => handleDownload({ request, response, endpoint, date })}
      noCloseOnConfirm
    >
      <div className='w-100'>
        <div className='flex flex-column margin-bottom'>
          <span className='bold margin-bottom-small'>{translate('query.logs.modal.functionality')}</span>
          <span>{translate('query.logs.'.concat(functionality)) || '-'}</span>
        </div>
        <div className='flex flex-row margin-bottom'>
          <div className='flex flex-column margin-right'>
            <span className='bold margin-bottom-small'>{translate('date_label')}</span>
            <span>{moment(date).format('DD/MM/YYYY')}</span>
          </div>
          <div className='flex flex-column margin-left'>
            <span className='bold margin-bottom-small'>{translate('onlineSchedule.hour')}</span>
            <span>{moment(date).format('HH:mm:ss')}</span>
          </div>
        </div>
        <div className='flex flex-column margin-bottom'>
          <div className='flex flex-row align-items-center margin-bottom-small'>
            <span className='bold margin-right'>{translate('queryLogs.table.column.endpoint')}</span>
            {endpoint && <TextLink
              isNotClickable={copied.endpoint}
              onClick={() => {
                navigator.clipboard.writeText(endpoint)
                setCopied({
                  ...DEFAULT_COPIED_STATE,
                  endpoint: true
                })
                if (timer) clearTimeout(timer)
                timer = setTimeout(() => setCopied(DEFAULT_COPIED_STATE), 3000)
              }}
              text={
                copied.endpoint
                  ? translate('mobile.update.download.apk.copied')
                  : translate('mobile.update.download.apk.copy')
              }
              textClass='small'
            />}
          </div>
          <span className='overflow-wrap-anywhere'>{endpoint || '-'}</span>
        </div>
        {functionality === 'demarcate' && (
          <div className='flex flex-column margin-bottom'>
            <span className='bold margin-bottom-small'>{translate('query.logs.modal.transactionSap')}</span>
            <span className='overflow-wrap-anywhere'>{transactionSap || '-'}</span>
          </div>
        )}
        <div className='flex flex-column margin-bottom'>
          <div className='flex flex-row align-items-center margin-bottom-small'>
            <span className='bold margin-right'>{translate('queryLogs.table.column.request')}</span>
            {request && <TextLink
              isNotClickable={copied.request}
              onClick={() => {
                navigator.clipboard.writeText(request)
                setCopied({
                  ...DEFAULT_COPIED_STATE,
                  request: true
                })
                if (timer) clearTimeout(timer)
                timer = setTimeout(() => setCopied(DEFAULT_COPIED_STATE), 3000)
              }}
              text={
                copied.request
                  ? translate('mobile.update.download.apk.copied')
                  : translate('query.logs.text.copy')
              }
              textClass='small'
            />}
          </div>
          <span className='overflow-wrap-anywhere'>{request || '-'}</span>
        </div>
        <div className='flex flex-column margin-bottom'>
          <div className='flex flex-row align-items-center margin-bottom-small'>
            <span className='bold margin-right'>{translate('queryLogs.table.column.response')}</span>
            {response && <TextLink
              isNotClickable={copied.response}
              onClick={() => {
                navigator.clipboard.writeText(response)
                setCopied({
                  ...DEFAULT_COPIED_STATE,
                  response: true
                })
                if (timer) clearTimeout(timer)
                timer = setTimeout(() => setCopied(DEFAULT_COPIED_STATE), 3000)
              }}
              text={
                copied.response
                  ? translate('mobile.update.download.apk.copied')
                  : translate('query.logs.text.copy')
              }
              textClass='small'
            />}
          </div>
          <span className='overflow-wrap-anywhere'>{displayResponse || '-'}</span>
        </div>
      </div>
    </Modal>
  )
}

QueryLogsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default QueryLogsModal
